module.exports = __webpack_public_path__ + "static/media/Maf_17Marzo.1f2e312b.jpg";